module.exports = __webpack_public_path__ + "img/my1.1ab2bcc5.png";